import { render, staticRenderFns } from "./secondaryNavigation.vue?vue&type=template&id=6f4f1cc6&scoped=true&"
import script from "./secondaryNavigation.vue?vue&type=script&lang=js&"
export * from "./secondaryNavigation.vue?vue&type=script&lang=js&"
import style0 from "./secondaryNavigation.vue?vue&type=style&index=0&id=6f4f1cc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4f1cc6",
  null
  
)

export default component.exports